import React, { useState } from "react";

import { GrsSearchQueryContext } from "./grs-search-context";
import { GrsSearchQuery } from "types/search-display";

interface grsSearchContextWrapperProps {
  children: React.ReactNode;
}

const GrsSearchContextWrapper = ({
  children,
}: grsSearchContextWrapperProps) => {
  const [grsSearchQueryState, setGrsSearchQueryState] =
    useState<GrsSearchQuery>({
      orgID: "",
    });

  const grsSearchContextValue = {
    grsSearchQueryState: grsSearchQueryState,
    setGrsSearchQueryState: setGrsSearchQueryState,
  };

  return (
    <GrsSearchQueryContext.Provider value={grsSearchContextValue}>
      {children}
    </GrsSearchQueryContext.Provider>
  );
};

export default GrsSearchContextWrapper;
